<section #homeContainer class="mt-10 px-10 md:flex animation-opacity">
  <div class="pb-5 w-full md:w-8/12">
    <div class="mb-10">
      <p class="text-4xl font-bold leading-tight">
        Hola! mi nombre es <span class="text-cmaxhm-blue">Carlos Castillo</span>, tambien conocido en internet como
        <span class="text-cmaxhm-blue">'Cmaxhm'</span>, Soy un Desarrollador Web trabajando con
        <a href="https://angular.io/" target="_blank">
          <img class="inline-block mr-3" width="30" src="./assets/images/technologies/angular.svg" title="Angular" alt="Angular">
          <span class="text-red-600">Angular</span>
        </a>.
      </p>
      <p class="text-4xl font-bold leading-tight">
        Necesitas trabajar en un proyecto? <a [routerLink]="['contacto']">Contáctame</a> y será un gusto ayudar! 😀
      </p>
      <div class="flex justify-start items-center gap-4">
        <a href="https://www.deviantart.com/carlosmax" target="_blank"><img width="16" src="./assets/images/deviantart.svg" alt="Deviantart"></a>
        <a href="https://github.com/cmaxhm" target="_blank"><img width="24" src="./assets/images/github.svg" alt="Github"></a>
        <a href="https://www.linkedin.com/in/cmaxhm" target="_blank"><img width="24" src="./assets/images/linkedin.svg" alt="LinkedIn"></a>
        <a href="https://twitter.com/cmaxhm" target="_blank"><img width="24" src="./assets/images/twitter.svg" alt="Twitter"></a>
      </div>
    </div>
    <h2 class="cmaxhm-title">Ultimos proyectos</h2>
    <section class="overflow-hidden">
      <article class="float-left" *ngFor="let project of projects">
        <a class="cursor-pointer" (click)="navigate(homeContainerElement, ['proyectos', project.projectSlug])">
          <img [src]="project.thumbnail" [alt]="project.name">
        </a>
      </article>
    </section>
  </div>
  <aside class="pb-5 w-full md:ml-10 md:w-4/12">
    <h2 class="cmaxhm-title">Ultimas publicaciones</h2>
    <ng-container *ngIf="!posts">
      <p class="text-center">Cargando...</p>
    </ng-container>
    <app-blog-post *ngFor="let post of posts | async" [post]="post"></app-blog-post>
    <a class="cmaxhm-link" href="https://blog.cmaxhm.com/" target="_blank">Visitar blog</a>
  </aside>
</section>
